// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.SideMenuPrivacy{
    max-width: 100%;
    max-height: 100%;
}

.SideMenuPrivacy_changePasswordButton{
    margin-bottom: 14px;
}

.SideMenuPrivacy_changePasswordForm{
    --formGap: 22px;
    display: flex;
    align-items: flex-end;
    gap: var(--formGap);
}`, "",{"version":3,"sources":["webpack://./src/pages/dashboardPage/components/sideMenu/SideMenuPrivacy.css"],"names":[],"mappings":";AACA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,aAAa;IACb,qBAAqB;IACrB,mBAAmB;AACvB","sourcesContent":["\n.SideMenuPrivacy{\n    max-width: 100%;\n    max-height: 100%;\n}\n\n.SideMenuPrivacy_changePasswordButton{\n    margin-bottom: 14px;\n}\n\n.SideMenuPrivacy_changePasswordForm{\n    --formGap: 22px;\n    display: flex;\n    align-items: flex-end;\n    gap: var(--formGap);\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
